import React, { useEffect,useState} from "react";
import './../App.css';

import ScrollToHashElement from './../ScrollToHashElement';
import HeaderHyfye from "./../officialheader";
import FooterHyfye from './../footer';
import PartnerMarquee from "./../partners";

const OfficialPages = () => {
     const [activeTab, setActiveTab] = useState("privacy");

const handleSidebarClick = (id) => {
  const legalContainer = document.getElementById("legal-content");

  // Main tabs
  if (["privacy", "terms", "disclaimer"].includes(id)) {
    setActiveTab(id); // set active tab

    if (legalContainer) {
      // Reset internal scroll of container to top
      legalContainer.scrollTo({ top: -100, behavior: "smooth" });

      // Scroll page to container position
      const yOffset = -280; // adjust based on sticky header height
      const y = legalContainer.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
  } 
  // Subsections
  else {
    const element = document.getElementById(id);
    if (element) {
      const yOffset = -110; // adjust for sticky nav
      const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
  }
};

const handleTabClick = (tab) => {
  handleSidebarClick(tab); // activeTab is set inside handleSidebarClick
};

// On first load: read hash and scroll
useEffect(() => {
  const fullHash = window.location.hash.replace('#', '');
  const baseTab = ["privacy", "terms", "disclaimer"].find(tab => fullHash.startsWith(tab)) || "privacy";

  // Set initial tab
  setActiveTab(baseTab);

  // Delay to ensure DOM is ready before scrolling
  setTimeout(() => {
    handleSidebarClick(fullHash || baseTab);
  }, 50);
}, []);


    return (
      <div className="App legal-page">
        <ScrollToHashElement />

        <header className="header_wrap fixed-top">
          <HeaderHyfye />
        </header>

        <main className="mt-20 text-[#333] bg-white min-h-screen">
          <div className="tabs-container">
            {/* Horizontal Tabs */}
            <div className="horizontal-tabs">
            
                <a
               
                  key="privacy"
                  href={`/pages/#privacy`}
                  className={`tab-item ${activeTab === "privacy" ? "active" : ""}`}
                  onClick={() => handleTabClick("privacy")}
                >
                Privacy Policy
                </a>
            
                <a
               
                  key="terms"
                  href={`/pages/#terms`}
                  className={`tab-item ${activeTab === "terms" ? "active" : ""}`}
                  onClick={() => handleTabClick("terms")}
                >
                Terms & Conditions
                </a>
                
                <a
               
                  key="disclaimer"
                  href={`/pages/#disclaimer`}
                  className={`tab-item ${activeTab === "disclaimer" ? "active" : ""}`}
                  onClick={() => handleTabClick("disclaimer")}
                >
                Disclaimer
                </a>
            </div>

            <div className="legal-layout">
              {/* Vertical Sidebar */}
              <aside className="vertical-sidebar">
                <nav>
                    {activeTab === "privacy" && (
                      <section   id="privacy">
                    <a
                      key="privacyIntroduction"
                      href={`/pages/#privacyIntroduction`}
                      className="sub-tab-item"
                      id="link-privacyIntroduction"
                      onClick={() => handleSidebarClick("privacyIntroduction")}
                    >
                      Introduction
                    </a>
                  <a
                      key="privacyInformation"
                      href={`/pages/#privacyInformation`}
                      className="sub-tab-item"
                      id="link-privacyInformation"
                      onClick={() => handleSidebarClick("privacyInformation")}
                    >
                      Information We Collect
                    </a>
                    <a key="privacyHowWeUseInformation"
                      href={`/pages/#privacyHowWeUseInformation`}
                      className="sub-tab-item"
                      id="link-privacyHowWeUseInformation"
                      onClick={() => handleSidebarClick("privacyHowWeUseInformation")}
                      >
                      How We Use Your Information
                    </a>
                    <a key="privacydatastoragesecurty"
                      href={`/pages/#privacydatastoragesecurty`}
                      className="sub-tab-item"
                      id="link-privacydatastoragesecurty"
                      onClick={() => handleSidebarClick("privacydatastoragesecurty")}
                        >
                      Data Storage and Security
                    </a>
                    <a key="privacyuserrightscontrol"
                      href={`/pages/#privacyuserrightscontrol`}
                      className="sub-tab-item" 
                      id="link-privacyuserrightscontrol"
                      onClick={() => handleSidebarClick("privacyuserrightscontrol")}>
                      User Rights and Control
                    </a>
                      <a key="privacyCookiesTracking"
                      href={`/pages/#privacyCookiesTracking`}
                        id="link-privacyCookiesTracking"
                      className="sub-tab-item" onClick={() => handleSidebarClick("privacyCookiesTracking")}>
                      Cookies and Tracking Technologies
                    </a>
                      <a key="privacyThirdParty"
                      href={`/pages/#privacyThirdParty`}
                          id="link-privacyThirdParty"
                      className="sub-tab-item" onClick={() => handleSidebarClick("privacyThirdParty")}>
                      Third-Party Links and Services
                    </a>
                    <a key="privacyChildren"
                      href={`/pages/#privacyChildren`}
                        id="link-privacyChildren"
                      className="sub-tab-item" onClick={() => handleSidebarClick("privacyChildren")}>
                      Compliance and Children’s Privacy
                    </a>
                    <a key="privacyDataRetention"
                      id="link-privacyDataRetention"
                      href={`/pages/#privacyDataRetention`}
                      className="sub-tab-item" onClick={() => handleSidebarClick("privacyDataRetention")}>
                      Data Retention
                    </a>
                    <a key="privacyChanges"
                      id="link-privacyChanges"
                      href={`/pages/#privacyChanges`}
                      className="sub-tab-item" onClick={() => handleSidebarClick("privacyChanges")}>
                      Changes to This Policy
                    </a>
                  <a key="privacyContactUs"
                    id="link-privacyContactUs"
                      href={`/pages/#privacyContactUs`}
                      className="sub-tab-item" onClick={() => handleSidebarClick("privacyContactUs")}>
                      Contact Us
                    </a></section>
                    )}
                      {activeTab === "terms" && (
                      <section id="terms">
                        <a
                          key="termsCondition"
                          href={`/pages/#termsCondition`}
                          className="sub-tab-item"
                          id="link-termsCondition"
                          onClick={() => handleSidebarClick("termsCondition")}
                        >
                          Terms & Conditions — Hyfye Project
                        </a>
                      <a
                          key="termsIntroduction"
                          href={`/pages/#termsIntroduction`}
                          className="sub-tab-item"
                          id="link-termsIntroduction"
                          onClick={() => handleSidebarClick("termsIntroduction")}
                        >
                          Introduction
                        </a>
                        <a key="termsNoInvestmentAdvice"
                          href={`/pages/#termsNoInvestmentAdvice`}
                          className="sub-tab-item"
                          id="link-termsNoInvestmentAdvice"
                          onClick={() => handleSidebarClick("termsNoInvestmentAdvice")}
                          >
                          No Investment Advice or Financial Offering
                        </a>
                        <a key="termsToken"
                          href={`/pages/#termsToken`}
                          className="sub-tab-item"
                          id="link-termsToken"
                          onClick={() => handleSidebarClick("termsToken")}
                            >
                          HYE Token Utility and Limitations
                        </a>
                        <a key="termsEligibility"
                          href={`/pages/#termsEligibility`}
                          className="sub-tab-item" 
                          id="link-termsEligibility"
                          onClick={() => handleSidebarClick("termsEligibility")}>
                          Eligibility and User Obligations
                        </a>
                          <a key="termsCompliance"
                          href={`/pages/#termsCompliance`}
                            id="link-termsCompliance"
                          className="sub-tab-item" onClick={() => handleSidebarClick("termsCompliance")}>
                          Regulatory Compliance
                        </a>
                          <a key="termsRisk"
                          href={`/pages/#termsRisk`}
                              id="link-termsRisk"
                          className="sub-tab-item" onClick={() => handleSidebarClick("termsRisk")}>
                          Risk Disclosure
                        </a>
                        <a key="termsAvailability"
                          href={`/pages/#termsAvailability`}
                            id="link-termsAvailability"
                          className="sub-tab-item" onClick={() => handleSidebarClick("termsAvailability")}>
                          Platform Availability and Modification
                        </a>
                        <a key="termsLiability"
                          id="link-termsLiability"
                          href={`/pages/#termsLiability`}
                          className="sub-tab-item" onClick={() => handleSidebarClick("termsLiability")}>
                          Limitation of Liability
                        </a>
                        <a key="termsIntellectual"
                          id="link-termsIntellectual"
                          href={`/pages/#termsIntellectual`}
                          className="sub-tab-item" onClick={() => handleSidebarClick("termsIntellectual")}>
                          Intellectual Property
                        </a>
                      <a key="termsGoverningLaw"
                        id="link-termsGoverningLaw"
                          href={`/pages/#termsGoverningLaw`}
                          className="sub-tab-item" onClick={() => handleSidebarClick("termsGoverningLaw")}>
                          Governing Law and Jurisdiction
                        </a>
                        <a key="termsChanges"
                        id="link-termsChanges"
                          href={`/pages/#termsChanges`}
                          className="sub-tab-item" onClick={() => handleSidebarClick("termsChanges")}>
                          Changes to the Terms
                        </a>
                        <a key="termsContactUs"
                        id="link-termsContactUs"
                          href={`/pages/#termsContactUs`}
                          className="sub-tab-item" onClick={() => handleSidebarClick("termsContactUs")}>
                          Contact Information
                        </a>
                        
                        
                        </section>
                    )}
                      {activeTab === "disclaimer" && (
                          <section id="disclaimer">
                        <a
                          key="disclaimerIntroduction"
                          href={`/pages/#disclaimerIntroduction`}
                          className="sub-tab-item"
                          id="link-disclaimerIntroduction"
                          onClick={() => handleSidebarClick("disclaimerIntroduction")}
                        >
                          Disclaimer
                        </a>
                        </section>
                    )}
                </nav>
              </aside>

              {/* Content Sections */}
              <section className="legal-content" id="legal-content">
                    {activeTab === "privacy" && (  
                      <>
                  <div key="privacyIntroduction" id="privacyIntroduction" className="legal-section">
                    <div className="section-header">
                      <h2 className="section-title">Introduction</h2>
                      <p className="section-desc">Hyfye respects your privacy and is committed to protecting the personal information you may provide while using our website, apps (Hyfye Minis), and ecosystem tools. This Privacy Policy explains how we collect, use, store, and protect your data.
                        By using Hyfye’s platform, website (hyfye.com), mobile applications, smart contracts, and services (collectively, the “Hyfye Ecosystem”), you consent to the practices described in this Privacy Policy.
                      </p>
                    </div>
                  
                  </div>
                <div key="privacyInformation" id="privacyInformation" className="legal-section">
                    <div className="section-header">
                      <h2 className="section-title">Information We Collect</h2>
                      <p className="section-desc">  
                        We collect limited user information, as Hyfye is built with privacy and decentralization in mind. 
                        However, the following types of data may be collected:
                      </p>
                      <ol type="A">
                        <li>
                          <h3>Information You Provide Voluntarily</h3>
                          <ul  type="dot">
                            <li>Email address (for support, beta access, and communication)</li>
                            <li>KYC data (if required by law for participation in token sales or staking pools)</li>
                            <li>Wallet address (for token transactions and reward distribution)</li>
                          </ul>
                        </li>
                        <li>
                          <h3>Automatically Collected Data</h3>
                          <ul>
                            <li>Browser/device information (IP address, type, OS)</li>
                            <li>Usage patterns (app features used, timestamps, click events)</li>
                            <li>Interaction logs with Hyfye Minis and reward systems</li>
                          </ul>
                        </li>
                        <li>
                          <h3>Third-Party Integrations</h3>
                          <ul>
                            <li>Health data from devices (e.g., HealthKit, Google Fit) with your consent</li>
                            <li>Education progress data via connected platforms (e.g., Duolingo, Coursera)</li>
                            <li>Geolocation data (only when necessary for specific Minis like Hyfye Green)</li>
                          </ul>
                        </li>
                      
                      </ol>
                    </div>
                    
                  </div>
                    <div key="privacyHowWeUseInformation" id="privacyHowWeUseInformation" className="legal-section">
                      <div className="section-header">
                      <h2 className="section-title">How We Use Your Information</h2>
                      <p className="section-desc"> We may use the collected data for the following purposes: </p>
                      <ul>
                            <li>To operate and maintain the Hyfye platform</li>
                            <li>To deliver rewards and HYE token incentives</li>
                            <li>To enhance user experience and app performance</li>
                            <li>To improve platform features and personalize content</li>
                            <li>To comply with legal obligations (e.g., KYC/AML)</li>
                            <li>To send occasional updates or security alerts</li>
                          </ul>
                          <p>We do not sell or rent your personal information to third parties.</p>
                      </div>
                  </div>
                  <div key="privacydatastoragesecurty" id="privacydatastoragesecurty" className="legal-section">
                      <div className="section-header">
                      <h2 className="section-title">Data Storage and Security</h2>
                      <p className="section-desc"> We implement <strong>industry-standard security practices</strong>  to protect your information: </p>
                      <ul>
                            <li>Data encryption in transit (SSL/TLS)</li>
                            <li>Wallet and user authentication protocols</li>
                            <li>Smart contract audits for all financial interactions</li>
                            <li>Secure off-chain KYC storage (when applicable)</li>
                          
                          </ul>
                          <p>However, <strong> blockchain transactions are inherently public.</strong> Your wallet activity may be visible on-chain and linked to your interactions within the ecosystem</p>
                      </div>
                  </div>
                  <div key="privacyuserrightscontrol" id="privacyuserrightscontrol" className="legal-section">
                      <div className="section-header">
                      <h2 className="section-title">User Rights and Control</h2>
                      <p className="section-desc"> You have the right to: </p>
                      <ul>
                            <li>Request access or deletion of your personal data (where applicable)</li>
                            <li>Withdraw consent for data collection (note: this may limit service use)</li>
                            <li>Opt out of marketing communications</li>
                            <li>Use the platform without creating a traditional user account</li>
                          
                          </ul>
                          <p> To make such requests, contact: <strong> hi@hyfye.com</strong></p>
                      </div>
                  </div>
                  <div key="privacyCookiesTracking" id="privacyCookiesTracking" className="legal-section">
                      <div className="section-header">
                      <h2 className="section-title">Cookies and Tracking Technologies</h2>
                      <p className="section-desc">Hyfye.com uses cookies and local storage for: </p>
                      <ul>
                            <li>Session management</li>
                            <li>Referral tracking</li>
                            <li>Analytics (e.g., Google Analytics, anonymized)</li>
                      
                          </ul>
                          <p> You may manage your cookie preferences through your browser settings.</p>
                      </div>
                  </div>
                    <div key="privacyThirdParty" id="privacyThirdParty" className="legal-section">
                      <div className="section-header">
                      <h2 className="section-title">Third-Party Links and Services</h2>
                      <p className="section-desc">The platform may contain links or integrations to third-party apps (e.g., Garmin, YouTube, MetaMask). We are not responsible for the privacy practices of external websites or platforms. We recommend reviewing their respective privacy policies. </p>
                      
                      </div>
                  </div>
                    <div key="privacyChildren" id="privacyChildren" className="legal-section">
                      <div className="section-header">
                      <h2 className="section-title">Compliance and Children’s Privacy</h2>
                      <p className="section-desc">Hyfye is not intended for children under the age of <strong>13</strong> (or as required by local laws). We do not knowingly collect data from minors. </p>
                      <p className="section-desc"> Hyfye complies with global privacy laws, including: </p>
                      <ul>
                          <li>GDPR (Europe)</li>
                          <li>CCPA (California)</li>
                          <li>UAE Federal Data Protection Law (if applicable)</li>
                          <li>Any local regulatory KYC/AML frameworks</li>
                        </ul>
                
                      </div>
                  </div>
                    <div key="privacyDataRetention" id="privacyDataRetention" className="legal-section">
                      <div className="section-header">
                      <h2 className="section-title">Data Retention</h2>
                      <p className="section-desc"> We retain user data <strong>only as long as necessary</strong> for the purposes described above, or to comply with legal obligations. On request, your data can be anonymized or deleted where permissible by law.</p>
                
                      </div>
                  </div>
                  <div key="privacyChanges" id="privacyChanges" className="legal-section">
                      <div className="section-header">
                      <h2 className="section-title">Changes to This Policy</h2>
                      <p className="section-desc">We may update this Privacy Policy from time to time. Updates will be posted on our website with a revised effective date. Continued use of the platform constitutes acceptance of the updated policy.</p>
                
                      </div>
                  </div>
                    <div key="privacyContactUs" id="privacyContactUs" className="legal-section">
                      <div className="section-header">
                      <h2 className="section-title">Contact Us</h2>
                      <p className="section-desc"> For questions, requests, or concerns about this Privacy Policy or data protection, please contact:<strong>hi@hyfye.com</strong></p>
                    </div>
                  </div></>  )}
                    {activeTab === "disclaimer" && (  
                      <>
                  <div key="disclaimerIntroduction" id="disclaimerIntroduction" className="legal-section">
                    <div className="section-header">
                      <h2 className="section-title">Disclaimer</h2>
                      <p className="section-desc">  
                        This website and the information provided herein are for general informational purposes only. Nothing on this site constitutes legal, financial, investment, or tax advice. The contents of this website are subject to change without prior notice and do not represent a binding commitment by the Hyfye team or its affiliates.
                        </p>
    <p className="section-desc">  
  Hyfye Coin (HYE) is a utility token designed for use within the Hyfye ecosystem. It is not intended to function as a security, equity, or any other regulated financial instrument. Use of the Hyfye platform, including participation in token-related activities or Mini apps, is entirely voluntary and subject to applicable laws in the user’s jurisdiction.

  </p><p className="section-desc">  
  Nothing on this website should be interpreted as a solicitation or offer to buy or sell securities or financial instruments of any kind. Holding or using HYE tokens does not grant ownership, profit-sharing rights, or governance control beyond its defined utility within the platform.


                      </p>
                      <p className="section-desc"> The Hyfye team disclaims all liability for any direct or indirect loss or damage resulting from reliance on the information provided on this website. All content is offered “as is,” without warranties of any kind, whether express or implied.

  </p>
                      <p className="section-desc"> By using this website, you agree to the terms outlined in this disclaimer and acknowledge that participation in decentralized technologies involves inherent risks. Users are encouraged to do their own research and consult qualified legal, financial, and tax advisors before making decisions related to Hyfye or the HYE token.

  </p>
                    </div>
                  
                  </div>
                  </>  )}
                      {activeTab === "terms" && (  <>
                  <div key="termsCondition" id="termsCondition" className="legal-section">
                    <div className="section-header">
                      <h2 className="section-title">Terms & Conditions — Hyfye Project</h2>
                      <p className="section-desc">    
                        These Terms and Conditions (“Terms”) govern your access to and use of the Hyfye platform, its associated applications (Hyfye Minis), and the native token Hyfye Coin (HYE). By interacting with any component of the Hyfye ecosystem, including purchasing or using HYE tokens, you agree to be legally bound by these Terms.
                      </p>
                    </div>
                  
                  </div>
                <div key="termsIntroduction" id="termsIntroduction" className="legal-section">
                    <div className="section-header">
                      <h2 className="section-title">Introduction</h2>
                      <p className="section-desc">  
                        Hyfye is a decentralized platform that rewards users for real-world activities such as walking, learning, engaging with content, and more. Through a modular app ecosystem and cross-platform utility token (HYE), Hyfye aims to build a global micro-earning economy. HYE tokens function purely as a utility token for use within the Hyfye network.
                      </p>
                  </div>
                    
                  </div>
                    <div key="termsNoInvestmentAdvice" id="termsNoInvestmentAdvice" className="legal-section">
                      <div className="section-header">
                      <h2 className="section-title">No Investment Advice or Financial Offering</h2>
                      <p className="section-desc"> The information provided in this whitepaper, on the Hyfye website, or through related channels does not constitute financial, investment, legal, or tax advice. Nothing herein shall be interpreted as an offer or solicitation to buy or sell securities or financial instruments. Users are strongly encouraged to seek independent professional advice before participating. </p>
                        
                      </div>
                  </div>
                  <div key="termsToken" id="termsToken" className="legal-section">
                      <div className="section-header">
                      <h2 className="section-title">HYE Token Utility and Limitations</h2>
                      <p className="section-desc"> The HYE token is designed exclusively for use in the Hyfye ecosystem to facilitate micro-rewards, in-app incentives, and platform-based services. It is not intended to function as a digital currency, asset-backed security, or speculative financial product. HYE does not entitle holders to voting rights (outside of governance mechanisms), dividends, revenue sharing, or equity in Hyfye or its affiliates.</p>
                      </div>
                  </div>
                  <div key="termsEligibility" id="termsEligibility" className="legal-section">
                      <div className="section-header">
                      <h2 className="section-title">Eligibility and User Obligations</h2>
                      <p className="section-desc"> To use the Hyfye platform or purchase HYE, you must: </p>
                      <ul>
                            <li>Be at least 18 years old.</li>
                            <li>Have the legal capacity to enter into binding agreements.</li>
                            <li>Not be a citizen or resident of a jurisdiction where participation in token sales or decentralized applications is prohibited or restricted.</li>
                            <li>Comply with your local laws regarding KYC/AML obligations, token usage, and income reporting.</li>
                          
                          </ul>
                          <p> Hyfye reserves the right to deny access or service to users from sanctioned regions or those in violation of these conditions.</p>
                      </div>
                  </div>
                  <div key="termsCompliance" id="termsCompliance" className="legal-section">
                      <div className="section-header">
                      <h2 className="section-title">Regulatory Compliance</h2>
                      <p className="section-desc">Hyfye is committed to operating in compliance with applicable global laws. While the project is decentralized, certain features (such as token presale, exchange listings, or fiat onramps) may be subject to KYC/AML verification, licensing, and regulatory oversight. Users are responsible for ensuring their compliance with local financial regulations.</p>
                      
                      </div>
                  </div>
                    <div key="termsRisk" id="termsRisk" className="legal-section">
                      <div className="section-header">
                      <h2 className="section-title">Risk Disclosure</h2>
                      <p className="section-desc"> Participation in the Hyfye ecosystem involves significant risks, including but not limited to:</p>
                        <ul>
                            <li>Loss or theft of tokens</li>
                            <li>Price volatility</li>
                            <li>Smart contract vulnerabilities</li>
                            <li>Regulatory changes</li>
                            <li>System downtime or bugs</li>
                          </ul>
                          <p>
                            Users acknowledge and accept these risks. Hyfye and its team members will not be held liable for any damage, losses, or claims arising from the use of the platform or participation in token-related activities.
                          </p>
                      </div>
                  </div>
                    <div key="termsAvailability" id="termsAvailability" className="legal-section">
                      <div className="section-header">
                      <h2 className="section-title">Platform Availability and Modification</h2>
                      <p className="section-desc"> Hyfye is a live, evolving ecosystem. The team reserves the right to: </p>
                      
                      <ul>
                          <li>Add, remove, or modify features or services</li>
                          <li>Update the tokenomics or reward mechanisms</li>
                          <li>Change earning rates and governance thresholds</li>
                          <li>Suspend services for maintenance or legal compliance</li>
                        </ul>
                      <p className="section-desc"> Such changes may occur with or without prior notice, and your continued use implies acceptance.</p>
                      </div>
                  </div>
                    <div key="termsLiability" id="termsLiability" className="legal-section">
                      <div className="section-header">
                      <h2 className="section-title">Limitation of Liability</h2>
                      <p className="section-desc">To the maximum extent permitted by law, Hyfye, its developers, contributors, and affiliates, shall not be liable for any:</p>
                        <ul>
                          <li>Direct, indirect, incidental, or consequential damages</li>
                          <li>Loss of data, profits, business, or goodwill</li>
                          <li>Costs resulting from errors, network issues, or user misuse</li>
                        </ul>
                          <p className="section-desc"> Use of the platform is at your own risk.</p>
                      </div>
                  </div>
                  <div key="termsIntellectual" id="termsIntellectual" className="legal-section">
                      <div className="section-header">
                      <h2 className="section-title">Intellectual Property</h2>
                      <p className="section-desc"> All content, code, branding, and documentation associated with Hyfye (including the whitepaper, app design, names, and trademarks) is the intellectual property of the Hyfye team or its licensors. You may not copy, distribute, or modify Hyfye assets without written consent.</p>
                      </div>
                  </div>
                    <div key="termsGoverningLaw" id="termsGoverningLaw" className="legal-section">
                      <div className="section-header">
                      <h2 className="section-title">Governing Law and Jurisdiction</h2>
                      <p className="section-desc"> These Terms shall be governed and interpreted under the laws of the jurisdiction where Hyfye is formally incorporated. In case of disputes, parties agree to resolve issues through binding arbitration or legal mediation within that jurisdiction.</p>
                    </div>
                  </div>
                    <div key="termsChanges" id="termsChanges" className="legal-section">
                      <div className="section-header">
                      <h2 className="section-title">Changes to the Terms</h2>
                      <p className="section-desc"> Hyfye may update or amend these Terms at any time. Changes will be effective upon publication through official Hyfye channels. It is your responsibility to review these Terms periodically. Continued use after updates indicates your acceptance of the revised Terms.</p>
                
                      </div>
                  </div>
                    <div key="termsContactUs" id="termsContactUs" className="legal-section">
                      <div className="section-header">
                      <h2 className="section-title">Contact Us</h2>
                      <p className="section-desc"> For any questions, feedback, or legal concerns regarding these Terms, please contact:<strong>hi@hyfye.com</strong></p>
                    </div>
                  </div>

                  </>  )}
              </section>
            </div>
          </div>
        </main>

        <footer>
          
          <FooterHyfye />
        </footer>

        <a
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          className="scrollup btn-default" style={{display:"inline;"}}
        >
          <i className="ion-ios-arrow-up"></i>
        </a>
      </div>
    );
};

export default OfficialPages;
